// Load Vuetify's full precompiled CSS bundle (every component's styles) instead
// of `vuetify/styles` (base/utilities only). We register all components globally
// below, so there's no treeshaking to preserve — and the webpack-plugin-vuetify
// `autoImport` per-component style injection only fires for production-compiled
// templates, leaving the dev build with no component styles. The full bundle is
// identical in dev and prod. See vue.config.js (autoImport disabled).
import 'vuetify/dist/vuetify.css'
import '@mdi/font/css/materialdesignicons.css'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'

import colors from '../schema/colors'

export default createVuetify({
  components,
  directives,
  defaults: {

    VTextField: { variant: 'underlined' },
    VTextarea: { variant: 'underlined' },
    VSelect: { variant: 'underlined' },
    VAutocomplete: { variant: 'underlined' },
    VCombobox: { variant: 'underlined' },
    VFileInput: { variant: 'underlined' },
    VNumberInput: { variant: 'underlined', controlVariant: 'hidden' },
    VProgressCircular: { bgColor: 'rgba(158, 158, 158, 0.4)' },
    VChip: { variant: 'flat' },
    // V3 v-tooltip defaults to a scale-snap transition; V2 used a soft opacity fade. Switch the global default to fade-transition.
    VTooltip: { transition: 'fade-transition' }
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors
      }
    }
  }
})
